import Vue from 'vue';
import VueRouter from 'vue-router';
import admin from './admin';
import bankApplications from "./bankApplications";

import middlewarePipeline from './middlewarePipeline';
import store from '../store';

Vue.use(VueRouter);


const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    children: [
      admin,
      bankApplications
    ]
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});


router.beforeEach(async(to, from, next) => {
  if (store.getters.authorized === undefined) {
    try {
      await store.dispatch('getUser');
      await Promise.all([
        store.dispatch('getI18n'),
        store.dispatch('getDesignConfig')
      ]);
      await store.dispatch('setTheme');
      document.querySelector('title').innerHTML = store.getters.voc.LKB_TITLE || '';
    }
    catch (e) {
      console.error(e);
      return next(false);
    }
  }

  if (store.getters.authorized === 'authorized') {
    if (to.name !== 'Home' && !store.getters.checkRoute(to.path) &&
      !(to.name === 'requestFl' && store.getters.checkRoute('/bank/applications'))) {
      return next('/');
    }
    if (!to.meta.middleware || !to.meta.middleware.length) {
      return next();
    }
    const middleware = to.meta.middleware;

    const context = {
      to,
      from,
      next,
      store,
    };

    return middleware[0]({
      context,
      nextMiddleware: middlewarePipeline(context, middleware, 1)
    });
  }
  else if (store.getters.authorized === 'no_authorized') {
    if (to.name === 'Login') {
      return next();
    } else {
      return next({ name: 'Login', params: { nextUrl: to.fullPath }, replace: true });
    }
  } else if (store.getters.authorized === 'blocked') {
    store.commit('setAccessUser');
  }
  return next(false);
});

export default router;
